// removed by extract-text-webpack-plugin
module.exports = {"status-banner-message":"status-banner-message___3ibw4","icon":"icon___37cVC","alert":"alert___2pUFK","message":"message___2Q8kg","header":"header___3_Kqy","body":"body___3SsXd","reserve":"reserve___SYrdC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/StatusBanner/StatusBannerMessage.scss
// module id = doBk
// module chunks = 46